module.exports = __webpack_public_path__ + "cd9ce63074089b2f2f2433cb83743536.pdf";